import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { DataSource } from '@angular/cdk/collections';
import { PostType, TheLoopService } from '@vendasta/the-loop';

interface PageOptions {
  index: number;
  size: number;
}

export class LoopPostTypesDataSource extends DataSource<PostType> {
  private pageOptions$$: BehaviorSubject<PageOptions> = new BehaviorSubject({ index: 0, size: 15 });
  private pageOptions$: Observable<PageOptions> = this.pageOptions$$.asObservable();

  pageSize$: Observable<number>;

  totalResults = 0;

  constructor(private loopService: TheLoopService) {
    super();
    this.pageSize$ = this.pageOptions$$.asObservable().pipe(map((p) => p.size));
  }

  private static getCursor(pageIndex: number, pageSize: number): string {
    const offset = pageSize * pageIndex;
    return window.btoa(offset.toString(10));
  }

  pageOptionsChanged(event: PageEvent): void {
    this.pageOptions$$.next({ index: event.pageIndex, size: event.pageSize });
  }

  connect(): Observable<PostType[]> {
    return this.pageOptions$.pipe(
      switchMap((pageOptions) =>
        this.loopService.listPostTypes(
          {},
          LoopPostTypesDataSource.getCursor(pageOptions.index, pageOptions.size),
          pageOptions.size,
        ),
      ),
      map((r) => {
        this.totalResults = r.totalResults;
        return r.results;
      }),
      publishReplay(1),
      refCount(),
    );
  }

  disconnect(): void {
    return;
  }
}

@Component({
  selector: 'app-loop-post-types-table',
  templateUrl: './post-types-table.component.html',
  styleUrls: ['./post-types-table.component.scss'],
  standalone: false,
})
export class PostTypesTableComponent implements OnInit {
  dataSource: LoopPostTypesDataSource;
  displayedColumns: string[] = ['name', 'channel', 'functions'];

  constructor(public loopService: TheLoopService) {}

  ngOnInit(): void {
    this.dataSource = new LoopPostTypesDataSource(this.loopService);
  }
}
